module.exports = __webpack_public_path__ + "mainassets/img/tile-2-1.15a54832.jpg";